<template>
  <ServiceFormWrapper :config="config" v-bind="$attrs">
    <template #edit-form="{ props, listeners }">
      <ServiceForm :schema="config.schema" v-bind="props" v-on="listeners" />
    </template>

    <template #form="{ props, listeners }">
      <ServiceForm :schema="config.schema" v-bind="props" v-on="listeners" />
    </template>
  </ServiceFormWrapper>
</template>

<script>
import ServiceFormWrapper from './ServiceFormWrapper';
import ServiceForm from './ServiceForm';
import RelatedServiceFormCatalogMixin from '../_mixins/RelatedServiceFormCatalog.mixin';
import { relatedServicesConfig } from '../_config';

export default {
  name: 'RelatedServiceFormWrapper',
  components: {
    ServiceFormWrapper,
    ServiceForm: {
      ...ServiceForm,
      ...{
        mixins: [...(ServiceForm.mixins || []), RelatedServiceFormCatalogMixin],
      },
    },
  },
  data: () => ({
    config: relatedServicesConfig,
  }),
};
</script>
